// 日切时间
const TIME_8_TO_8 = '08:00:00' // 8点 - 8点
const TIME_12_TO_12 = '12:00:00' // 12点 - 12点

const map = new Map([
  [TIME_8_TO_8, { mean: '8点 - 8点' }],
  [TIME_12_TO_12, { mean: '12点 - 12点' }]
])

export default {
  map,
  TIME_8_TO_8,
  TIME_12_TO_12
}
